import type { ComponentRegistry } from '@/components/report-canvas/registry';
import { builtinChartRegistry } from '@/components/report-canvas/builtinCharts';
import { vegaWidgetRegistry } from '@/components/report-canvas/vega/VegaChartWidget';
import { tableWidgetRegistry } from '@/components/report-canvas/charts/TableWidget';

/**
 * Component registry for the query-builder report surface: the five builtin
 * charts, the Table, plus the agent-authorable vega-chart escape hatch. Shared by the
 * builder page (palette + canvas + AI generation) and the print page so a
 * saved report renders identically in both. No self-contained widgets — every
 * component here binds the single query-result dataset.
 */
export const queryBuilderReportRegistry: ComponentRegistry = {
  ...builtinChartRegistry,
  ...tableWidgetRegistry,
  ...vegaWidgetRegistry,
};
